import React, { useEffect, useState } from 'react';

const HERO_IMAGES = [
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-1.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-2.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-3.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-4.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-5.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-6.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-7.jpg`,
  `${process.env.PUBLIC_URL || ''}/images/hero/hero-8.jpg`,
];

const INTERVAL_MS = 4500;

const HeroSlideshow = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setActive((prev) => (prev + 1) % HERO_IMAGES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="hero-slideshow" aria-hidden="true">
      {HERO_IMAGES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          className={`hero-slideshow-img${i === active ? ' is-active' : ''}`}
          loading={i === 0 ? 'eager' : 'lazy'}
        />
      ))}
      <div className="hero-slideshow-dots">
        {HERO_IMAGES.map((_, i) => (
          <span
            key={i}
            className={`hero-slideshow-dot${i === active ? ' is-active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlideshow;
